export const CONSULTANT_NUMBER_QUERY_PARAM_KEY = 'chPwdUsr';

export const RETURN_URL_QUERY_PARAM_KEY = 'returnUrl';

export const INVITATION_OFFER_HASH = '#open-invitation-offer';
